import { useState } from "react";
import { post } from "../networking/RequestService";

function useUploadDealAttachments({ onSuccess, onError } = {}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const uploadDealAttachments = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { files } = params;

        if (!files || files.length === 0) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            setLoading(false);
            return { error: errorMessage };
        }

        try {
            const response = await post({ fn: "uploadDealAttachments", files, ...params });
            if (typeof onSuccess === "function") {
                onSuccess(response.data);
            }
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { uploadDealAttachments, loading, error };
}

export default useUploadDealAttachments;
